export function isIOS() {
  const userAgent = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(userAgent) ||
  // iPad can report itself as Mac
  /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;
}
export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
}
export function isIOSStandalone() {
  return isIOS() && isStandalone();
}
flarum.reg.add('fof-pwa', 'forum/utils/platforrm', { isIOS: isIOS,isStandalone: isStandalone,isIOSStandalone: isIOSStandalone, });